// 電話番号バリデーション用の共通正規表現（10〜11桁の数字）
export const PHONE_PATTERN = /^\d{10,11}$/;

// 電話番号の部分一致検索用の正規表現（1〜11桁の数字。部分入力での絞り込みを許容）
export const PHONE_SEARCH_PATTERN = /^\d{1,11}$/;
